import axios from 'axios';

const VITE_API_IBGE_URL = import.meta.env.VITE_API_IBGE_URL;

const axiosIBGE = axios.create({
  baseURL: VITE_API_IBGE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function buscarEstados() {
  try {
    const { data } = await axiosIBGE.get('/estados');
    return data.sort((a, b) => a.nome.localeCompare(b.nome));
  } catch (error) {
    console.error('Erro ao buscar estados:', error);
    throw new Error('Erro ao buscar estados do IBGE');
  }
}

export async function buscarMunicipiosPorEstado(estadoId) {
  if (!estadoId) return [];

  try {
    const { data } = await axiosIBGE.get(`/estados/${estadoId}/municipios?orderBy=nome`);
    return data.sort((a, b) => a.nome.localeCompare(b.nome));
  } catch (error) {
    console.error('Erro ao buscar municípios:', error);
    throw new Error('Erro ao buscar municípios do IBGE');
  }
}

export async function buscarMunicipioPorId(municipioId) {
  if (!municipioId) return [];

  const ids = Array.isArray(municipioId) ? municipioId.join('|') : municipioId;

  try {
    const { data } = await axiosIBGE.get(`/municipios/${ids}`);
    return Array.isArray(data) ? data : [data];
  } catch (error) {
    console.error('Erro ao buscar município(s) por ID:', error);
    throw new Error('Erro ao buscar município(s) do IBGE');
  }
}
